/**
 * Employee Data Table Component
 */
import React from 'react';
import { Employee } from './empManagement';
import './empDataTable.css';

export interface EmpDataTableProps {
  employees: Employee[];
  onEmployeeClick?: (employee: Employee) => void;
  onManageClick?: (employee: Employee) => void;
}

function statusBadge(employee: Employee): { label: string; className: string } {
  if (employee.needsFinalize) {
    return {
      label: 'アーカイブ未作成',
      className: 'emp-data-table__badge emp-data-table__badge--pending',
    };
  }
  if (employee.hireLifecycle === 'rehire_in_progress') {
    return {
      label: '再雇用手続き中',
      className: 'emp-data-table__badge emp-data-table__badge--rehire',
    };
  }
  if (employee.hireLifecycle === 'resigned') {
    return {
      label: '退職',
      className: 'emp-data-table__badge emp-data-table__badge--resigned',
    };
  }
  return {
    label: '登録完了',
    className: 'emp-data-table__badge emp-data-table__badge--done',
  };
}

const EmpDataTable: React.FC<EmpDataTableProps> = ({
  employees,
  onEmployeeClick,
  onManageClick,
}) => {
  const handleRowClick = (employee: Employee) => {
    onEmployeeClick?.(employee);
  };

  return (
    <div className="emp-data-table">
      <div className="emp-data-table__container">
        <table className="emp-data-table__table">
          <thead>
            <tr>
              <th>番号</th>
              <th>従業員ID</th>
              <th>氏名</th>
              <th>登録日</th>
              <th>生年月日</th>
              <th>メールアドレス</th>
              <th>状態</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {employees.length > 0 ? (
              employees.map((employee, index) => {
                const badge = statusBadge(employee);
                return (
                  <tr
                    key={employee.id}
                    className="emp-data-table__row"
                    onClick={() => handleRowClick(employee)}
                  >
                    <td>{index + 1}</td>
                    <td>{employee.empId}</td>
                    <td>{employee.name}</td>
                    <td>{employee.registrationDate}</td>
                    <td>{employee.birthDate}</td>
                    <td>{employee.email}</td>
                    <td>
                      <span className={badge.className}>{badge.label}</span>
                    </td>
                    <td>
                      <button
                        type="button"
                        className="emp-data-table__manage-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          onManageClick?.(employee);
                        }}
                      >
                        管理
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={8} className="emp-data-table__empty">
                  該当する従業員はいません
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmpDataTable;
